import IPlayer from './core/IPlayer'
import Timer from './Timer'
import { MessageBox } from 'element-ui'
import Player from './platforms/Video'
import DocumentPlayer from './platforms/Document'
import { PlayerStatus } from './common/enums'
import LearningMedia from '@api/model/learning/LearningMedia'

import LearningMode from '@api/model/learning/LearningMode'

export enum PlayerHelperEvent {
  // 提交事件
  commit = 'commit',
  end = 'end'
}

interface IOption {
  playMedia?: LearningMedia
  player?: IPlayer
}

class AutoContinuePlayWidget extends Timer {
  timer = 0
  hideTip = false

  constructor() {
    super(() => {
      this.close()
    }, 5000)
  }

  mouseleave() {
    this.start()
  }

  mouseenter() {
    this.stop()
  }

  close() {
    this.hideTip = true
  }
}

export enum PlayState {
  pause,
  play,
  end
}

class PlayerHelper extends Timer {
  // 播放器实例
  player: IPlayer
  // 播放器容器id
  playerBoxId = `player_box_${new Date().getTime()}`
  // 当前学习进度
  learningSchedule = 0
  // 当前媒体是否完成学习，指进度大于等于 100
  isComplete = false
  // 学习提交的时间间隔
  learningIntervalTime: number
  // 自动播放的提示条
  autoContinuePlayWidget = new AutoContinuePlayWidget()
  // 参数
  options: IOption
  // 学习模式，默认预览
  learningMode: LearningMode = LearningMode.Preview
  // 是否优先播放视频
  isVideoPlaying: boolean
  // 播放的媒体
  playMedia: LearningMedia

  onLearningEvent = false
  timerCount = 0

  async init() {
    await Player.installPlayerEvn()
  }

  constructor(options: IOption) {
    super(() => {
      this.startSchedule()
    }, 1000)
    this.options = options

    this.setCurrentPlayerType(true)
    // 5秒后隐藏自动续播的那个提示
    this.autoContinuePlayWidget.start()
  }

  /**
   * 学习模式
   */
  learning() {
    // 当前学习进度
    this.learningSchedule = (this.playMedia?.currentLearningSchedule / 100) * this.playMedia?.mediaTimeLength
    // 控制学习的拖拽播放，在没有学过的进度中不能拖拽观看
    this.player.on('seek', (time: number) => {
      console.log(time)
      // 新版本需求说不要这个拖拽限制的功能。我拿掉咯
      // if (!this.isComplete) {
      //   if (time > this.learningSchedule) {
      //     this.player.play(this.learningSchedule)

      //   }
      // }
    })
    // 监听播放器的课件结束事件， 将事件向上层吐出去
    this.player.on('end', () => {
      this.emit(PlayerHelperEvent.end, this.getSubmitSchedule(PlayState.end))
    })

    this.player.on(PlayerStatus.error, () => {
      this.destroy()
    })

    // 启动定时器，一般是学习的进度计时
    this.start()
  }

  whileLeaningModeDoLearning() {
    // 学习模式将会启动学习的计时器。
    if (this.learningMode === LearningMode.Learning && !this.onLearningEvent) {
      this.onLearningEvent = true
      this.learning()
    }
  }

  /**
   * 计算要提交的学习进度
   * @param playState
   */
  getSubmitSchedule(playState: PlayState) {
    let schedule = 100
    if (this.playMedia.mediaTimeLength) {
      schedule = this.player.getSchedule()
    }
    return {
      schedule,
      currentTime: this.player.getTime(),
      playState
    }
  }

  /**
   * 试听的处理事情
   */
  listen() {
    // todo
  }

  /**
   * 预览，先调用试听的
   */
  preview() {
    this.listen()
  }

  /**
   * 只有学习才会启动的定时器提交用的。
   */
  startSchedule() {
    if (this.player) {
      this.timerCount++
      if (!(this.timerCount % this.learningIntervalTime)) {
        this.emit(PlayerHelperEvent.commit, this.getSubmitSchedule(PlayState.play))
      }
    }
  }

  destroy() {
    this.stop()
    this.player && this.player.destroy()
    delete this.player
  }

  async doRefreshTip() {
    this.player.stop()
    try {
      await MessageBox.alert('您当前播放的视频因为某些原因需要重新刷新才可正常学习。请知晓！！', '温馨提示', {
        showClose: false
      })
      window.location.reload()
    } catch (e) {
      console.log(e)
    }
  }

  setCurrentPlayerType(isVideoPlay: boolean) {
    this.isVideoPlaying = isVideoPlay
  }

  async changeMedia(learningMedia: LearningMedia) {
    const isSame = this.playMedia?.mediaId === learningMedia.mediaId
    this.playMedia = learningMedia
    const schedule = (this.playMedia?.currentLearningSchedule / 100) * this.playMedia?.mediaTimeLength
    if (learningMedia.lastMediaPlayScale <= 30) {
      this.autoContinuePlayWidget.close()
    }
    this.isComplete = this.playMedia.currentLearningSchedule >= 100

    if (!learningMedia || !learningMedia.mediaId) return
    if (learningMedia?.isDocument()) {
      const playerOptions = {
        id: this.playerBoxId,
        width: '',
        height: '',
        playerConfig: {
          duration: learningMedia.mediaTimeLength,
          currentTime: schedule,
          src: `/mfs/${learningMedia.getDocumentRelativePath()}`
        }
      }
      this.player && this.player.destroy()
      this.onLearningEvent = false
      /* eslint-disable no-new */
      this.player = new DocumentPlayer(playerOptions)
    }
    const playTime =
      this.playMedia?.lastMediaPlayScale >= this.playMedia?.mediaTimeLength ? 0 : this.playMedia?.lastMediaPlayScale
    if (learningMedia?.isVideo()) {
      if (!(this.player instanceof Player)) {
        this.player && this.player.destroy()
        /* eslint-disable no-new */
        this.player = new Player({
          id: this.playerBoxId,
          width: '100%',
          sources: learningMedia.getHuaWeiVideoResources(),
          playerConfig: {
            autoplay: 'auto',
            currentTime: this.playMedia.lastMediaPlayScale,
            playbackRates: []
          }
        })
      } else {
        const result = this.isVideoPlaying
          ? learningMedia.getHuaWeiVideoResources()
          : [learningMedia.getHuaWeiAudioResource()]
        this.player.updateSource(result)
        this.player.play(isSame ? this.player.getTime() : playTime)
      }
    }

    this.whileLeaningModeDoLearning()
  }
}

export default PlayerHelper
